
export default {
  name: 'HomeProPlusBanner',
}
